import * as React from 'react';
import { useSelector } from 'react-redux';

import { SalesLinks } from '../../components/SalesLinks';
import { getSalesLinks } from '../../selectors/getSalesLinks';
import { ESalesType } from '../../types/offersData';
import { trackSalesLinkClick } from './tracking';

export function SalesLinksContainer() {
  const salesLinks = useSelector(getSalesLinks);

  const handleLinkClick = React.useCallback((type: ESalesType) => {
    trackSalesLinkClick(type);
  }, []);

  if (!salesLinks.length) {
    return null;
  }

  return <SalesLinks links={salesLinks} onLinkClick={handleLinkClick} />;
}
